/**
 * Server-rendered idle screen layouts a device can be pinned to; `null` on the
 * device means the fleet default. Ids are the render service's template ids
 * (Device.screenTemplate; registry in onlycat-device-screens src/templates,
 * whitelist DEVICE_SCREEN_TEMPLATES in onlycat-services-shared). Each layout
 * pairs with a preview component in DeviceScreenPreviews.
 */
export const SCREEN_TEMPLATES = [
    {
        id: 'last-event',
        labelKey: 'screen_templates.last-event',
        noteKey: 'device_screen.note_last_event',
    },
    {
        id: 'activity',
        labelKey: 'screen_templates.activity',
        noteKey: 'device_screen.note_activity',
    },
    {
        id: 'latest-recent',
        labelKey: 'screen_templates.latest-recent',
        noteKey: 'device_screen.note_latest_recent',
    },
    {
        id: 'inside-outside',
        labelKey: 'screen_templates.inside-outside',
        noteKey: 'device_screen.note_inside_outside',
    },
] as const;

export type ScreenTemplateId = (typeof SCREEN_TEMPLATES)[number]['id'];

export const screenTemplateById = (id: string | null | undefined) =>
    SCREEN_TEMPLATES.find((template) => template.id === id);
